import { Model, belongsTo } from 'miragejs';

export default Model.extend({
  artist: belongsTo('artist', { inverse: null }),
  category: belongsTo('category', { inverse: null }),
  productTrack: belongsTo('product-track', { inverse: 'contributors' }),
});
